import dynamic from 'next/dynamic';
import { ComponentConfig } from '@zapier/builder.io-kit';

export const config: ComponentConfig = {
  name: 'Service Icon',
  description:
    'Renders an icon representing a service (aka app, aka integration).',
  category: 'Zapier Sign Up Blocks',
  // @ts-ignore
  component: dynamic(() =>
    import('@zapier/design-system-patterns').then(mod => mod.ServiceIcon)
  ),
  inputs: [
    {
      name: 'hasShadow',
      friendlyName: 'Has Shadow',
      type: 'boolean',
      defaultValue: false,
      helperText:
        'Applies a shadow to the ServiceIcon. It is recommended to use hasShadow at sizes 80px and larger.',
    },
    {
      name: 'serviceName',
      friendlyName: 'Service Name',
      type: 'string',
      defaultValue: '',
      helperText:
        'The name of the service whose icon is being displayed (used as alt text for the icon), e.g., "Google Sheets".',
    },
    {
      name: 'src',
      friendlyName: 'Icon Image',
      type: 'string',
      defaultValue: '',
      helperText:
        'A URL for the service icon image to be rendered. If this is an Imgix URL, a large-format image can be used and the image will automatically be resized.',
    },
    {
      name: 'size',
      friendlyName: 'Size',
      type: 'number',
      defaultValue: 80,
      enum: [{ label: '80px', value: 80 }],
      helperText:
        'Sets the width and height of the icon (since it is a square), in pixels. The list of possible sizes is finite to enforce consistency across our UI.',
    },
  ],
};
